
import { Component, Vue } from 'vue-property-decorator'
import { IMG_HOST } from '@/config/env'
import FilePlus from '@/common/class/FilePlus'
import UploadImg from '@/common/class/UploadImg'

const UPLOAD_STATUS = {
    SUCCESS: {
        KEY: 'success',
        DESC: '上传成功'
    },
    FAIL: {
        KEY: 'fail',
        DESC: '上传失败'
    },
    WAIT: {
        KEY: 'wait',
        DESC: '等待上传'
    }
}

@Component({
    name: 'upload-photo'
})
export default class extends Vue {
    private uploadLoading = false
    private uploadStatus = UPLOAD_STATUS.WAIT.KEY
    private file: any = null
    
    get fileName() {
        return this.file ? this.file.name : '暂未选择文件'
    }
    get uploadStatusDesc() {
        if (!this.file) {
            return '暂未选择文件'
        }
        return Reflect.get(UPLOAD_STATUS, this.uploadStatus.toLocaleUpperCase()).DESC
    }
    get photoTempSrc() {
        if (!this.file) return ''
        return new FilePlus(this.file, { type: 'image' }).getImageTempUrl()
    }
    get imgHost() {
        return IMG_HOST + this.fileName
    }
    get isSuccess() {
        return this.uploadStatus === UPLOAD_STATUS.SUCCESS.KEY
    }

    onSelectFile() {
        (this.$refs.fileEl as any).click()
    }
    
    onFileChange({ target }: any) {
        this.file = target.files[0]
        this.uploadStatus = UPLOAD_STATUS.WAIT.KEY
    }

    async onUploadFile() {
        if (this.uploadStatus === UPLOAD_STATUS.SUCCESS.KEY) {
            return this.$minfo('文件已上传')
        }
        this.uploadLoading = true
        const result = await new UploadImg(this.file).upload({ origin: true })
        this.uploadLoading = false
        if (result.error) {
            this.uploadStatus = UPLOAD_STATUS.FAIL.KEY
            return this.$merror('上传失败')
        } else {
            this.uploadStatus = UPLOAD_STATUS.SUCCESS.KEY
            return this.$msuccess('上传成功')
        }
    }

    onResetFile() {
        this.file = null
        this.uploadLoading = false
        this.uploadStatus = UPLOAD_STATUS.WAIT.KEY
    }
}
